 var gantt=window.gantt
 export class GanttFeatures{
    features;
    constructor(){
        this.features=  {
            'HighlightTaskPositionOnDrag':new HighlightTaskPositionOnDrag(),
            // 'CorrectTaskPositionOnDrag':new CorrectTaskPositionOnDrag()
        }
       
    }
    enableAll(){
        this.toArray().forEach(e=>e.enable());
    }
    toArray = function () {
        var array = [];
        let features=this.features;
        Object.keys(features).forEach(function (key) {
          array.push(features[key]);
        });
        return array;
      };

 }
export class GanttFeature{
    gantt ;
    enabled;
    constructor(gantt){
        this.gantt=gantt;
    }
    enable(){
        this.enabled=true;
    }
    disable(){
this.enabled=false;
    }
}

export class HighlightTaskPositionOnDrag extends GanttFeature{
constructor(gantt){
    super(gantt);

}
enable(){
    gantt.config.show_drag_vertical = true;
	gantt.config.show_drag_dates = true;
	gantt.config.drag_label_width = 70;
	gantt.config.drag_date =  '%Y-%m-%d';
	gantt.templates.drag_date = null;

    gantt.templates.drag_date = gantt.date.date_to_str(gantt.config.drag_date);
   let self=this;
    //highlight area
    gantt.addTaskLayer({
			renderer: function highlight_area(task) {
				var sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
					wrapper = document.createElement("div");

                    self.addElement({
					css: 'drag_move_vertical',
					left: sizes.left + 'px',
					top: 0,
					width: sizes.width + 'px',
					height: gantt.getVisibleTaskCount() * gantt.config.row_height + "px",
					wrapper: wrapper
				});

				self.addElement({
					css: 'drag_move_horizontal',
					left: 0,
					top: sizes.top + 'px',
					width: 100 + "%",
					height: gantt.config.row_height - 1 + 'px',
					wrapper: wrapper
				});

				return wrapper;
			} ,
			filter: function (task) {
				return  gantt.config.show_drag_vertical && task.id ==  gantt.getState().drag_id;
			}
		});

		//show drag dates
		gantt.addTaskLayer({
			renderer: function show_dates(task) {
				var sizes = gantt.getTaskPosition(task, task.start_date, task.end_date),
					wrapper = document.createElement('div');
 
                    self.addElement({
					css: "drag_move_start drag_date",
					left: sizes.left - gantt.config.drag_label_width + 'px',
					top: sizes.top + 'px',
					width: gantt.config.drag_label_width + 'px',
					height: gantt.config.row_height - 1 + 'px',
					html: gantt.templates.drag_date(task.start_date),
					wrapper: wrapper
				});

				self.addElement({
					css: "drag_move_end drag_date",
					left: sizes.left + sizes.width + 'px',
					top: sizes.top + 'px',
					width: gantt.config.drag_label_width + 'px',
					height: gantt.config.row_height - 1 + 'px',
					html: gantt.templates.drag_date(task.end_date),
					wrapper: wrapper
				}) ;

				return wrapper;
			},
			filter: function (task) {
				return gantt.config.show_drag_dates && task.id == gantt.getState().drag_id;
			}
		});

	

	// end highlight drag position
}
disable(){

}
 addElement=function(config) {
    var div = document.createElement('div');
    div.style.position = "absolute";
    div.className = config.css || "";
    div.style.left = config.left;
    div.style.width = config.width;
    div.style.height = config.height;
    div.style.lineHeight = config.height;
    div.style.top = config.top;
    if (config.html)
        div.innerHTML = config.html;
    if (config.wrapper)
        config.wrapper.appendChild(div);
    return div;
}
 

}

export class CorrectTaskPositionOnDrag extends GanttFeature{
    enable(){
        gantt.config.work_time = true;
	gantt.config.correct_work_time = true;
    gantt.config.duration_unit = "day";
	gantt.config.scale_height = 20 * 3;
	//gantt.config.row_height = 30;

    var weekScaleTemplate = function (date) {
		var dateToStr = gantt.date.date_to_str("%d %M");
		var weekNum = gantt.date.date_to_str("(week %W)");
		var endDate = gantt.date.add(gantt.date.add(date, 1, "week"), -1, "day");
		return dateToStr(date) + " - " + dateToStr(endDate) + " " + weekNum(date);
	};
    gantt.config.scales = [
		{unit: "month", step: 1, format: "%F, %Y"},
		{unit: "week", step: 1, format: weekScaleTemplate},
		{unit: "day", step: 1, format: "%D, %d"},
        // {unit: "hour", step: 3, format: "%H:%i"}
	];

	gantt.templates.timeline_cell_class = function (task, date) {
		if (!gantt.isWorkTime(date))
			return "week_end";
		return "";
	};
    }
}

export class AutoSchedule extends GanttFeature{
    enable(){
        super.enable();
        
        gantt.plugins({
            auto_scheduling: true
        });
        gantt.config.auto_scheduling = true;
    }
}

export class WBSCodes extends GanttFeature{
    enable(){
        super.enable();
        
        gantt.config.auto_types = true;
    }
}